import BudgetPage from "./pages/BudgetPage";

function App() {
  return (
    <>
      <BudgetPage />
    </>
  );
}

export default App;
